import { render, staticRenderFns } from "./DocDownload.vue?vue&type=template&id=7302a9f4&"
import script from "./DocDownload.vue?vue&type=script&lang=js&"
export * from "./DocDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports